import { DoorWorkingModes } from '../../enum/DoorWorkingModes'

export const DoorWorkingModeById = [
  DoorWorkingModes.DoorReleased,
  DoorWorkingModes.CardVerification,
  DoorWorkingModes.FirstReaderDisabled,
  DoorWorkingModes.SecondReaderDisabled,
  DoorWorkingModes.AllReadersDisabled,
]
